<!--
  Customized v-tooltip on a v-sheet basis.

  Responsibility: provide a theme-sensible tooltip

  Usage of activator (triggering element) :
  - by slot: wrap the activator into the slot
  - by props: provide an HTMLElement or the "parent" keyword
-->
<script setup lang="ts">
// Imported type HTMLElement triggers warning due to a Vue bug with defineProps.
// An issue is closed: https://github.com/vuejs/core/issues/5804 but will lead to a future enhancement: https://github.com/vuejs/core/issues/4294

type Props = {
  activator?: HTMLElement | 'parent';
  location?: 'start' | 'end' | 'top' | 'bottom';
  titleDivider?: boolean;
  infoIcon?: boolean;
  maxWidth?: number | string;
};

const props = withDefaults(defineProps<Props>(), {
  location: 'bottom',
});
</script>

<template>
  <v-tooltip :activator="props.activator ? props.activator : undefined" :location="props.location">
    <!-- Do not provide slot if props has been provided-->
    <template v-if="!props.activator" #activator="slotProps">
      <slot name="activator" :isActive="slotProps.isActive" :props="slotProps.props"></slot>
    </template>
    <v-card class="mx-n4 my-n2 rounded-sm elevation-8" :max-width="props.maxWidth">
      <template #title>
        <slot name="title"> </slot>
      </template>

      <v-divider v-if="props.titleDivider" class="w-100"></v-divider>

      <div class="text-body-3 pa-4">
        <slot name="content"> </slot>
      </div>

      <slot> </slot>
    </v-card>
  </v-tooltip>
</template>
